import React, { useState,useEffect } from "react";
import { Input, InputNumber, Space, Table } from "antd";

const CommonDataTable = ({
  columns,
  dataSource,
  loading,
  tableTitle,
  search
}) => {
   
   const [pageSize,setPageSize] = useState(10)
   const [searchText, setSearchText] = useState("");
   const [filteredData, setFilteredData] = useState(dataSource);

   
  useEffect(() => {
    setFilteredData(dataSource);
  }, [dataSource]);


  
  //function for search items in table
  const handleSearch = (value) => {
    setSearchText(value);
    // console.log(value,'val')
    
    if (!value) {
      setFilteredData(dataSource);
      return;
    }

    const filtered = dataSource.filter((item) => {
      return Object.values(item).some(
        (val) => val && 
        val.toString().toLowerCase().includes(value.toLowerCase())
      );
    });

    setFilteredData(filtered);
  };

  return (
    <>
      <div>{tableTitle}</div>
      {
        search && 
        <div className="d-flex justify-content-between mt-5">
          <div className="d-flex gap-1">
            <p className="mt-1">Show</p>
            <div>
              <InputNumber defaultValue={pageSize} 
                onChange={(value) => setPageSize(value)}
              />
            </div>
            <p className="mt-1">Entries</p>
          </div>
          <div className="d-flex gap-2">
            <p className="mt-1">Search</p>
            <div>
              <Space.Compact>
                <Input defaultValue="" placeholder="Search" 
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </Space.Compact>
            </div>
          </div>
       </div>
      }
      <Table
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey={(record) => record.key || record.id || Math.random()}
        bordered
        pagination={{ pageSize: pageSize || 10 }}
        className="mt-50"
        scroll={{ x: "max-content" }} 
      />
    </>
  );
};

export default CommonDataTable;
